module.exports = __webpack_public_path__ + "img/leftbicep-endomorph-male.b8722fc3.svg";